import { type Clip, ClipType } from '@air/api/types';

export {
  type Dimension,
  getBackgroundPositionFromFrame,
  getDimensions,
  getSpriteStyles,
} from '@air/utils-clips';

export const SCRUBBABLE_THUMBNAIL_INDICATOR_WIDTH = 2;

export const clipSupportsStaticThumbnail = (clip: Clip) =>
  !!clip.assets.spriteSheet?.src && clip.type === ClipType.video && Number.isInteger(clip.position?.start.thumbnail);
